import * as actions from './actions.js';

const store = {
	namespaced: true,
	state: {},
	actions
};

export default store;
